import QueueIcon from '@mui/icons-material/Queue';
import { MenuItem, ListItemIcon } from '@mui/material';

type GroupCreatorProps = {
    onClick?: () => void;
    disabled?: boolean;
};

export const GroupCreator = ({
    onClick = () => undefined,
    disabled,
}: GroupCreatorProps): JSX.Element => {
    return (
        <MenuItem onClick={onClick} disabled={disabled}>
            <ListItemIcon sx={{ mx: -1 }}>
                <QueueIcon />
            </ListItemIcon>
            Создать группу из выбранных
        </MenuItem>
    );
};
